export const Category = {
  CH: 'CH',
  CH_APPOINTMENTS: 'CH Appointments',
  CH_CONSENT_AND_PERMISSION: 'CH Consents and Permission',
  CH_HEALTH_RECORDS: 'CH Health Records',
  CH_MEDICATIONS: 'CH Medications',
  CH_PAYMENTS_AND_FINANCIAL: 'CH Payments and Financials',
  CH_SCHOOL: 'CH School',
  CH_TEST_REPORTS: 'CH Test Reports',
  CHILDREN_HEALTH_RECORDS: 'Children Health Records',
  FAMILY_HEALTH_RECORDS: 'Family Health Records',
  FF: 'FF',
  FF_APPOINTMENTS: 'FF Appointments',
  FF_HEALTH_RECORDS: 'FF Health Records',
  FF_HEALTH_RISK: 'FF Health Risk',
  FF_HEALTHIER_SG: 'FF Healthier SG',
  FF_MEDICATIONS: 'FF Medications',
  FF_PAYMENTS_AND_FINANCIAL: 'FF Payments and Financials',
  FF_TEST_REPORTS: 'FF Test Reports',
  PERSONAL_HEALTH_RECORDS: 'Personal Health Records',
  PH: 'PH',
  PH_APPOINTMENTS: 'PH Appointments',
  PH_CONSENT_AND_PERMISSION: 'PH Consents and Permission',
  PH_HEALTH_RECORDS: 'PH Health Records',
  PH_HEALTH_RISK: 'PH Health Risk',
  PH_HEALTHIER_SG: 'PH Healthier SG',
  PH_MEDICATIONS: 'PH Medications',
  PH_PAYMENT_AND_FINANCIAL: 'PH Payments and Financials',
  PH_TEST_REPORTS: 'PH Test Reports',
} as const;

export const CategoryType = {
  SERVICE_CATEGORY: 'ServiceCategory',
  SUB_CATEGORY: 'SubCategory',
} as const;
